import HttpService from '../http-service/http-service';
import { DSL_API_PATH, DSL_BASE_URL } from '../../constants';
import {
    ImgSpcApiResponse,
    ImgSpcDealerModelDetailsApiDataTHPHVN,
    ImgSpcDealerModelDetailsApiDataZAF,
    ImgSpcResultsForDerivativeApiDataData,
    ResultsForDerivativeParams,
} from '../../models/serice-price-calculator-model';

export type ImgSpcResultsForDerivativeResponseApiResponse = ImgSpcApiResponse<
    ImgSpcResultsForDerivativeApiDataData
>;

export type ImgSpcDealerModelDetailApiResponseZAF = ImgSpcApiResponse<
    ImgSpcDealerModelDetailsApiDataZAF
>;

export type ImgSpcDealerModelDetailApiResponseTHPHVN = ImgSpcApiResponse<
    ImgSpcDealerModelDetailsApiDataTHPHVN
>;

export default class ImgSpcServices {
    async resultsForDerivative(
        resultsForDerivativeParams: ResultsForDerivativeParams
    ) {
        const resultsForDerivativeUrl = `${DSL_BASE_URL +
            DSL_API_PATH.SPC_IMG}/results-for-derivative`;
        return await HttpService.get<
            ImgSpcResultsForDerivativeResponseApiResponse
        >(resultsForDerivativeUrl, true, {
            params: resultsForDerivativeParams,
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(({ data }) => data);
    }

    async dealerModelDetails(current3LetterCountryCode: string) {
        const dealerModelDetailsUrl = `${DSL_BASE_URL +
            DSL_API_PATH.SPC_IMG}/dealer-model-details/${current3LetterCountryCode}`;
        return await HttpService.get<
            | ImgSpcDealerModelDetailApiResponseZAF
            | ImgSpcDealerModelDetailApiResponseTHPHVN
        >(dealerModelDetailsUrl, true, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(({ data }) => data);
    }
}
